module.exports = __webpack_public_path__ + "static/media/mortar-pestle.25029c70.svg";